import { createSelector } from "reselect";
import { UserQueryFactory } from "./user/user.queries";
import {
    AccountQueryFactory,
    dictionarySelector,
    itemSelector,
    listSelector,
    parameterisedItemSelector
} from "./query-facade";
import { MembershipUser } from "./membership-user/membership-user.model";
import { MembershipQueryFactory } from "./membership/membership.queries";

export class QueryFactoryHelpers {

    constructor(
        protected userQueryFactory: UserQueryFactory,
        protected accountQueryFactory: AccountQueryFactory,
        protected membershipQueryFactory: MembershipQueryFactory
    ) {

    }

    get isActiveUserOwner(): itemSelector<boolean> {
        return createSelector(this.userQueryFactory.selected, this.accountQueryFactory.selected,
            (user, account) => account.owner === user.id
        );
    }

    get isAccountOwnerByAccount(): dictionarySelector<boolean> {
        return createSelector(this.accountQueryFactory.items, this.userQueryFactory.selected,
            (accounts, user): { [id: string]: boolean } => {
                const result = {};
                accounts.forEach(account => result[account.id] = account.owner === user.id);
                return result;
            });

    }

    isAccountOwner(accountId: string): itemSelector<boolean> {
        return createSelector(this.accountQueryFactory.items, this.userQueryFactory.selected,
            (accounts, user) => {
                return accounts.filter(account => account.id === accountId && account.owner === user.id).length > 0;
            });
    }

    get isOwner(): parameterisedItemSelector<boolean> {
        return (userId: string) => {
            return createSelector(this.accountQueryFactory.selected, account => account.owner === userId);
        };
    }

    get membershipsUsers(): listSelector<MembershipUser> {
        return createSelector(this.membershipQueryFactory.byActiveAccount, this.userQueryFactory.items,
            (memberships, users) => {
                return memberships.map(membership => new MembershipUser({
                    id: membership.id,
                    account: membership.account,
                    user: users.find(user => user.id === membership.user),
                    accessGroups: membership.accessGroups,
                    contactTypes: membership.contactTypes,
                    lookupTypes: membership.lookupTypes,
                    jobTypes: membership.jobTypes,
                    taskTypes: membership.taskTypes,
                    jobStatuses: membership.jobStatuses,
                    admin: membership.admin
                }));
            });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/query-factory-helpers.ts